import React, { Fragment } from 'react'

// components
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'

// icons
import {
    faArchive,
    faBalanceScale,
    faBarcode,
    faCartPlus,
    faDollarSign,
    faFileAlt,
    faKeyboard,
    faMagic,
    faMinus,
    faPercent,
    faPlus,
    faSortNumericUp,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// routes
import { withRouter } from 'react-router-dom'

import Select from 'react-select'
import useAdd from './hooks/useAdd'

function AddArticulo({ history }) {
    const {
        formikArticle,
        codigosBarra,
        familias,
        marcas,
        unidadMedidas,
        handleCodigosBarra,
        deleteCodigoBarra,
        generateAndAddCode128,
    } = useAdd(history, true)

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faBarcode} title={'Articulos'} />
                </div>

                <div className="bg-gris p-4">
                    <form
                        onSubmit={formikArticle.handleSubmit}
                        onKeyDown={(e) => {
                            // Prevenir el envío del formulario cuando se presiona Enter
                            // Solo permitir el envío cuando se hace clic explícitamente en el botón
                            if (e.key === 'Enter' && e.target.tagName !== 'BUTTON') {
                                e.preventDefault()
                            }
                        }}
                    >
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputNombre">Nombre</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faCartPlus} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputNombre"
                                        name="nombre"
                                        className="form-control"
                                        placeholder="Ej. Lacteos, Gaseosas..."
                                        value={formikArticle.values.nombre}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                                {formikArticle.touched.nombre &&
                                    formikArticle.errors.nombre ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.nombre}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputCosto">Costo</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        step="any"
                                        id="inputCosto"
                                        name="costo"
                                        placeholder="Ej. 100, 200,..."
                                        value={formikArticle.values.costo}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                                {formikArticle.touched.costo && formikArticle.errors.costo ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.costo}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputPrecioFinal">
                                    Precio Final
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faDollarSign} />
                                    </span>
                                    <input
                                        type="number"
                                        step="any"
                                        id="inputPrecioFinal"
                                        name="precioFinal"
                                        className="form-control"
                                        placeholder="$250"
                                        value={formikArticle.values.precioFinal}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputPGanancia">
                                    Porcentaje Ganancia
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faPercent} />
                                    </span>
                                    <input
                                        type="text"
                                        id="inputPGanancia"
                                        name="porcentajeGanancia"
                                        className="form-control"
                                        placeholder="10, 20"
                                        value={formikArticle.values.porcentajeGanancia}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputPesable">Pesable</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faArchive} />
                                    </span>
                                    <select
                                        id="inputPesable"
                                        className="custom-select"
                                        name="pesable"
                                        value={formikArticle.values.pesable}
                                        onChange={(e) => {
                                            formikArticle.handleChange(e)
                                            if (String(e.target.value) !== 'true') {
                                                formikArticle.setFieldValue(
                                                    'porcentajePerdida',
                                                    0
                                                )
                                            }
                                        }}
                                        onBlur={formikArticle.handleBlur}
                                    >
                                        <option value={true}>Si</option>
                                        <option value={false}>No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputPesoPromedio">
                                    Peso promedio
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faBalanceScale}
                                        />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputPesoPromedio"
                                        name="pesoPromedio"
                                        placeholder="medida en gramos"
                                        value={formikArticle.values.pesoPromedio}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                            </div>

                            {String(formikArticle.values.pesable) === 'true' && (
                                <div className="form-group col-md-4">
                                    <label htmlFor="inputPorcentajePerdida">
                                        Porcentaje Perdida
                                    </label>
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faPercent} />
                                        </span>
                                        <input
                                            type="text"
                                            id="inputPorcentajePerdida"
                                            name="porcentajePerdida"
                                            className="form-control"
                                            placeholder="0 - 100"
                                            value={
                                                formikArticle.values
                                                    .porcentajePerdida
                                            }
                                            onChange={formikArticle.handleChange}
                                            onBlur={formikArticle.handleBlur}
                                        />
                                    </div>
                                    {formikArticle.touched.porcentajePerdida &&
                                    formikArticle.errors.porcentajePerdida ? (
                                        <small className="form-text text-danger">
                                            {
                                                formikArticle.errors
                                                    .porcentajePerdida
                                            }
                                        </small>
                                    ) : null}
                                </div>
                            )}
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputBalanza">Balanza</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faBalanceScale}
                                        />
                                    </span>
                                    <select
                                        id="inputBalanza"
                                        className="custom-select"
                                        name="balanza"
                                        value={formikArticle.values.balanza}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    >
                                        <option value={true}>Si</option>
                                        <option value={false}>No</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputCodProducto">
                                    Codigo del producto
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faKeyboard} />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputCodProducto"
                                        name="codigo"
                                        placeholder="Ej 100"
                                        value={formikArticle.values.codigo}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                                {formikArticle.touched.codigo &&
                                    formikArticle.errors.codigo ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.codigo}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputDescripcion">
                                    Descripcion
                                </label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon icon={faFileAlt} />
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="inputDescripcion"
                                        name="descripcion"
                                        placeholder="Ej. producto envasado"
                                        value={formikArticle.values.descripcion}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label htmlFor="inputFamilia">Familia</label>
                                <div>
                                    <Select
                                        placeholder={'Seleccionar una familia'}
                                        options={familias}
                                        onChange={(value) =>
                                            formikArticle.setFieldValue(
                                                'familia',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formikArticle.touched.familia &&
                                    formikArticle.errors.familia ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.familia}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputMarca">Marca</label>
                                <div>
                                    <Select
                                        placeholder={'Seleccionar una marca'}
                                        options={marcas}
                                        onChange={(value) =>
                                            formikArticle.setFieldValue('marca', value)
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formikArticle.touched.marca && formikArticle.errors.marca ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.marca}
                                    </small>
                                ) : null}
                            </div>

                            <div className="form-group col-md-4">
                                <label htmlFor="inputUnidadMedida">
                                    Unidad Medida
                                </label>
                                <div>
                                    <Select
                                        placeholder={
                                            'Seleccionar una unidad de medida'
                                        }
                                        options={unidadMedidas}
                                        onChange={(value) =>
                                            formikArticle.setFieldValue(
                                                'unidadMedida',
                                                value
                                            )
                                        }
                                        getOptionValue={(values) => values.id}
                                        getOptionLabel={(values) =>
                                            values.nombre
                                        }
                                    ></Select>
                                </div>
                                {formikArticle.touched.unidadMedida &&
                                    formikArticle.errors.unidadMedida ? (
                                    <small className="form-text text-danger">
                                        {formikArticle.errors.unidadMedida}
                                    </small>
                                ) : null}
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputPuntos">Puntos</label>
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        id="inputGroupPrepend"
                                    >
                                        <FontAwesomeIcon
                                            icon={faSortNumericUp}
                                        />
                                    </span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        step="any"
                                        id="inputPuntos"
                                        name="puntos"
                                        placeholder="Ej. 0"
                                        value={formikArticle.values.puntos}
                                        onChange={formikArticle.handleChange}
                                        onBlur={formikArticle.handleBlur}
                                    />
                                </div>
                            </div>

                            <div className="form-group col-md-6">
                                <label htmlFor="inputCodBarra">
                                    Codigos de Barra
                                </label>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span
                                            className="input-group-text"
                                            id="inputGroupPrepend"
                                        >
                                            <FontAwesomeIcon icon={faBarcode} />
                                        </span>
                                    </div>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="inputCodBarra"
                                        name="codigoBarra"
                                        placeholder="Ej. 77555511999"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                handleCodigosBarra(e)
                                            }
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            title="Generar código Code 128"
                                            onClick={generateAndAddCode128}
                                        >
                                            <FontAwesomeIcon icon={faMagic} />{' '}
                                            Generar Codigo de Barra
                                        </button>
                                    </div>
                                </div>
                                <ul className="list-group">
                                    {codigosBarra.map((cb) => {
                                        return (
                                            <li
                                                id={'cod' + cb.codigo}
                                                key={parseInt(cb.codigo)}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                {cb.codigo}
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={(e) =>
                                                        deleteCodigoBarra(
                                                            e,
                                                            cb.codigo
                                                        )
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faMinus}
                                                    />
                                                </button>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>

                        <div className="text-center">
                            <button
                                type="submit"
                                className="btn btn-outline-success"
                            >
                                <FontAwesomeIcon icon={faPlus} /> Crear Articulo
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddArticulo)
